import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles} from '../style/gstheme';
import withGS from '../withGShoc';

class ProjectSummary extends React.Component {

  render() {

    const { data, classes } = this.props;

    return (
      <span data-test="project-summary" className={classes.subMainHeading}>{
        data._notAvailable ?
          "Either no permission to view project information or it has been deleted."
          :
          data.title[data.defaultLang]}</span>
    );
  }
}

ProjectSummary.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired
};

export default withStyles(styles)(withGS(ProjectSummary));